import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeopleRemove2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="people-remove-2"><path d="M14.75 6.5C14.75 8.57107 13.0711 10.25 11 10.25C8.92893 10.25 7.25 8.57107 7.25 6.5C7.25 4.42893 8.92893 2.75 11 2.75C13.0711 2.75 14.75 4.42893 14.75 6.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M11 13.25C6.8098 13.25 3.86894 16.3254 3.5 20.25H18.5C18.1311 16.3254 15.1902 13.25 11 13.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M17 11.25H23" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconPeopleRemove2;
